<div class="common-circle-loader" role="status" aria-live="polite" [attr.aria-label]="message">
  <mat-progress-spinner mode="indeterminate" [diameter]="diameter" class="spinner"></mat-progress-spinner>
  @if (message) {
    <p class="message">{{ message }}</p>
  }
</div>
